export default __webpack_public_path__ + "static/media/carleton.2b775f27.png";